import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  Annotation,
  GET_GLOBAL_ANNOTATIONS_PATH,
  GetGlobalAnnotationsErrorDto,
  GetGlobalAnnotationsQueryParams,
  GetGlobalAnnotationsSuccessDto,
} from '@/api/rest/resources/types/conversation';

export const useGlobalAnnotations = (filters?: GetGlobalAnnotationsQueryParams) => {
  const queryParams = filters ?? undefined;

  const queryFn = () => {
    return getRequest<GetGlobalAnnotationsSuccessDto>(GET_GLOBAL_ANNOTATIONS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<GetGlobalAnnotationsSuccessDto, GetGlobalAnnotationsErrorDto>({
    queryKey: ['annotations', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 2,
    select: (data: Annotation[]) => data,
  });
};
